var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 23.8129L2.66699 22.4795V27.8129H6.66699V23.8129ZM29.3336 22.4795L25.3336 23.8129V27.8129H29.3336V22.4795Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.47949C6.66699 4.27035 8.45785 2.47949 10.6669 2.47949H21.3336C23.5428 2.47949 25.3336 4.27035 25.3336 6.47949V18.4794H6.66699V6.47949Z",
    fill: "url(#paint0_linear_1437_9551)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66684 9.14648H5.3335C3.12437 9.14648 1.3335 10.9374 1.3335 13.1465V19.8132C1.3335 22.0223 3.12436 23.8132 5.3335 23.8132H26.6668C28.8759 23.8132 30.6668 22.0223 30.6668 19.8132V13.1465C30.6668 10.9374 28.8759 9.14648 26.6668 9.14648H25.3335V18.4798L25.2157 18.1266C24.4898 15.9488 22.4517 14.4798 20.1561 14.4798H11.8442C9.54859 14.4798 7.51052 15.9488 6.78458 18.1266L6.66684 18.4798V9.14648Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1437_9551",
    x1: 25.3336,
    y1: 18.4794,
    x2: 3.93147,
    y2: 8.14412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.87f496d4fbd81867353ace18e72f4a15.svg";
export { ForwardRef as ReactComponent };